<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/fault/standard/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('tingjiyuanyindaima')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('tingjiyuanyinmingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('tingjiyuanyinfenlei')">
            <yi_dictionary_select :type="'SHUTDOWN_REASON_CLASSIFICATION'" :ids.sync="yt.conditions.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button :loading="yt.loading" @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button :loading="yt.loading" @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary" v-if="utils.checkPower('web_base_stop_reason_create')">
          {{ $t('xinzeng') }}
        </el-button>
        <!-- 2023007版本已取消该按钮 -->
        <!-- <el-button size="mini" @click="resetShutdownReason" plain>
					{{$t('chongzhitingjiyuanyin')}}
				</el-button> -->
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)" v-if="utils.checkPower('web_base_stop_reason_update')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" :loading="yt.editObj.loading" @click="yt.remove(scope.row, '/web/equipment/fault/standard/delete')" v-if="utils.checkPower('web_base_stop_reason_delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 底部插槽 -->
      <!-- <div slot="footer"></div> -->
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('tingjiyuanyinfenlei')" required>
            <yi_dictionary_select :type="'SHUTDOWN_REASON_CLASSIFICATION'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('tingjiyuanyindaima')" required="required">
            <el-input v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('tingjiyuanyinmingcheng')" required="required">
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jiadonglvjisuan')">
            <el-select v-model="yt.editObj.operationRateCalculate" :placeholder="$t('qingxuanze')" clearable>
              <el-option v-for="item in operationRateOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/equipment/fault/standard/create')" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('tingjiyuanyinfenlei')" required>
            <yi_dictionary_select :type="'SHUTDOWN_REASON_CLASSIFICATION'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('tingjiyuanyindaima')" required="required">
            <el-input v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('tingjiyuanyinmingcheng')" required="required">
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
					<el-form-item :label="$t('jiadonglvjisuan')">
            <el-select v-model="yt.editObj.operationRateCalculate" :placeholder="$t('qingxuanze')" clearable>
              <el-option v-for="item in operationRateOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/equipment/fault/standard/update')" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'admin_data_template_stop_reason_list',

  data() {
    return {
			operationRateOptions: [
        { value: 1, label: this.$t('yunxing') },
				{ value: 0, label: this.$t('feiyunxing') }
			],
      columns: [
        {
          label: 'tingjiyuanyindaima',
          prop: 'code',
          width: 130
        },
        {
          label: 'tingjiyuanyinmingcheng',
          prop: 'name',
          width: 130
        },
        {
          label: 'tingjiyuanyinfenlei',
          prop: 'type',
          type: 'dictionary',
          key: 'SHUTDOWN_REASON_CLASSIFICATION'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 130,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
      this.yt.SELECT_URL = '/web/equipment/fault/standard/getFaultStandardByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'name';
    }, 300);
  },
  methods: {
    resetShutdownReason() {
      const confirmText = [this.$t('stop_reason_waring'), this.$t('reset_warning').concat('?')];
      const newDatas = [];
      const h = this.$createElement;
      for (const i in confirmText) {
        newDatas.push(h('p', null, confirmText[i]));
      }
      this.$confirm('', this.$t('tishi'), {
        message: h('div', null, newDatas),
        confirmButtonText: this.$t('quedingchongzhi'),
        cancelButtonText: this.$t('no'),
        confirmButtonClass: 'primary',
        type: 'warning'
      }).then(() => {
        this.http
          .post('/web/equipment/fault/standard/reset', {})
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.get(1);
          })
          .cache(error => {
            this.utils.errorMessage(this.$t(error));
          });
      });
    },
    // 重置
    clear() {
      this.yt.conditions = {
        pageNum: 1,
        pageSize: 10
      };
      this.yt.get(1);
    }
  }
};
</script>
